export default (data, uid, name) => {
    return (dispatch) => {
        dispatch({type: 'FETCH_SUCCESS', payload: {status:data, uid: uid, name: name}})
    }
}